module.exports = axe-core-react;